import { MenuItem } from '@ui-lib/components';
import { NavigationMenuEnum } from './model/navigation-menu.enum';
import { UserPermissionEnum } from './model/user-permission.enum';

export const MENU_ITEMS: MenuItem<NavigationMenuEnum>[] = [
  {
    titleTranslateKey: NavigationMenuEnum.PoolSettings,
    url: '/',
    icon: 'currencies',
    requiredPermission: UserPermissionEnum.PoolCommissionRead,
  },
  {
    titleTranslateKey: NavigationMenuEnum.Finance,
    url: '/finance',
    icon: 'btc',
    requiredPermission: UserPermissionEnum.WithdrawalRequestRead,
  },
  {
    titleTranslateKey: NavigationMenuEnum.Users,
    url: '/users',
    icon: 'users-group',
    requiredPermission: UserPermissionEnum.UserRead,
  },
  {
    titleTranslateKey: NavigationMenuEnum.Roles,
    url: '/roles',
    icon: 'sticker-smile',
    requiredPermission: UserPermissionEnum.RoleRead,
  },
  {
    titleTranslateKey: NavigationMenuEnum.SystemNotifications,
    url: '/system-notifications',
    icon: 'bell',
    requiredPermission: UserPermissionEnum.PortalGlobalNotificationManage,
  },
];
